interface ShowAllIconProps {
  size?: number;
  className?: string;
}

/** Unfold: a bar with chevrons opening away from it — "reveal the posts hidden above and below".
 *  Same shape as createShowAllSvg in svg-helpers.ts (used where the DOM is built by hand). */
const ShowAllIcon: React.FC<ShowAllIconProps> = ({ size = 16, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
    aria-hidden="true"
  >
    <path d="M5 5l3-3 3 3" />
    <path d="M3 8h10" />
    <path d="M5 11l3 3 3-3" />
  </svg>
);

export default ShowAllIcon;
